import React, { useState, useEffect } from "react"
import _ from "lodash"

import RowAddRemove from "components/table/carousel/row-add-remove"
import { SingleRowCarouselState_s, MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

type Item_t = object & {
  i: number
}

const InputTypeWithinLease = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    amttype: null,
    inputtype: "withinLease",
    payoutdetail: {
      payoutMode: "namedItem",
      payoutNamedItemId: null
    },
    tenantcapitaldetail: {
      state: "withinLease",
      items: []
    }
  }
  const emptyItem = {
    new: null,
    renewal: null,
    month: null
  }

  const [data, setData] = useState<object|null>({...props.rowData})
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {"new": item.new, "renewal": item.renewal, "month": item.month, i }}), "month") : [{...emptyItem, i:0}])
  const payoutOptions = _.map(
    _.get(props, "namedItems.payout"),
    item => {
      return {value: item.payoutid, label: item.code}
    }
  )
  const payoutDefault = _.get(props.defaults, "tiPayout.payoutNamedItemId")
  const amtTypeDefault = _.includes(props.defaults['tiAmtType'], "Amt") ? "% of Rent" : props.defaults['tiAmtType']

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'withinLease') {
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = _.cloneDeep(items);
    nextItems = nextItems.map(item => {
      return {month: item.month, new: item.new, renewal: item.renewal}
    })

    _.set(nextData, "inputtype", "withinLease")
    _.set(nextData, "tenantcapitaldetail", {
      state: "withinLease"
    })
    _.set(nextData, "tenantcapitaldetail.amtType", _.get(localCache, "tenantcapitaldetail.amtType") || amtTypeDefault)
    _.set(nextData, "tenantcapitaldetail.payout", {
      payoutMode: "namedItem",
      payoutNamedItemId: _.get(localCache, "tenantcapitaldetail.payout.payoutNamedItemId") || payoutDefault
    })
    _.set(nextData, "tenantcapitaldetail.items", nextItems)

    if(field === "tenantcapitaldetail.payout.payoutNamedItemId") {
      _.set(localCache, "tenantcapitaldetail.payout", {
        payoutMode: "namedItem",
        payoutNamedItemId: val
      })
      _.set(nextData, "tenantcapitaldetail.payout", _.get(localCache, "tenantcapitaldetail.payout"))
    } else if(field === "tenantcapitaldetail.amtType") {
      _.set(localCache, "tenantcapitaldetail.amtType", val)
      _.set(nextData, "tenantcapitaldetail.amtType", val)
    } else if(!_.isArray(field)) {
      nextData[field] = localCache[field] = val
    } else {
      if(nextItems[field[0]][field[1]] === val) return
      nextItems[field[0]][field[1]] = val
      _.set(localCache, "tenantcapitaldetail.items", nextItems)
      _.set(nextData, "tenantcapitaldetail.items", _.sortBy(nextItems, "month"))
      setItems(nextItems.map((item, i) => { return {new: item.new, renewal: item.renewal, month: item.month, i}}));
    }
    setData(localCache)

    nextData["amtnew"] = null
    nextData["amtrenew"] = null
    nextData["amttype"] = null
    nextData["inflationdetail"] = null
    nextData["payoutdetail"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = items.map((item, i) => { return {...item}})

    _.set(nextData, "inputtype", "withinLease")
    _.set(nextData, "tenantcapitaldetail", {
      state: "withinLease"
    })
    _.set(nextData, "tenantcapitaldetail.amtType", _.get(localCache, "tenantcapitaldetail.amtType") || amtTypeDefault)
    _.set(nextData, "tenantcapitaldetail.payout", {
      payoutMode: "namedItem",
      payoutNamedItemId: _.get(localCache, "tenantcapitaldetail.payout.payoutNamedItemId") || payoutDefault
    })

    setItems(nextItems)
    const strippedItems = nextItems.map(({i, ...rest}) => rest)
    _.set(nextData, "tenantcapitaldetail.items", strippedItems)

    props.persist(nextData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i')
  const params = {
    data: items,
    persist: updateData
  }

  const attrs = (field) => field_attrs('ti', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('ti', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: 20}} className="carousel-single-row">
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated amt-type-field" data={data} attrs={attrs} default={amtTypeDefault}
            field="tenantcapitaldetail.amtType" options={[
              '% of Rent',
              '% of Rent + Recovery',
              '% of Rent: Ignore Free',
              '% of Rent + Recovery: Ignore Free',
              '% of All Revenues'
            ]} persist={updateData} />
        </div>
        <div>
          <label>Payout</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="tenantcapitaldetail.payout.payoutNamedItemId"
            default={payoutDefault}
            options={payoutOptions} persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Month</label> }
              <NumberInput className="automated static-year-input" attrs={item_attrs} field={[row['i'], 'month']} {...params} />
            </div>
            <div>
              { i === 0 && <label>New</label> }
              <NumberInput className="automated new-field" attrs={item_attrs} field={[row['i'], 'new']} {...params} readPrecision={4} writePrecision={4} persist={updateData} />
            </div>
            <div>
              { i === 0 && <label>Renewal</label> }
              <NumberInput className="automated renewal-field" attrs={item_attrs} field={[row['i'], 'renewal']} {...params} readPrecision={4} writePrecision={4} persist={updateData} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={renderItems} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default InputTypeWithinLease
